ACC.newSupportTopics = {
  helptopicscategories: '.ph-helptopicscategories__boxes',
  questionSection: '.ph-question-sec',
  customtopPos: 'ph-customtopPos',
  stickyheaderCls: '.ph-help-stickyheader',
  subTopicId: '.ph-tosup-topic',
  gaDefaultText: 'CustomerSupport | ',
  showStickyHeader: function() {
    if ($('.ph-countdownbarcontainer').is(':visible')) {
      $(ACC.newSupportTopics.stickyheaderCls).addClass(ACC.newSupportTopics.customtopPos);
    } else {
      $(ACC.newSupportTopics.stickyheaderCls).removeClass(ACC.newSupportTopics.customtopPos);
    }

    $(ACC.newSupportTopics.stickyheaderCls).show();
  },
  hideStickyHeader: function() {
    $(ACC.newSupportTopics.stickyheaderCls).removeClass(ACC.newSupportTopics.customtopPos);
    $(ACC.newSupportTopics.stickyheaderCls).hide();
  }
};
$(document).ready(function() {
  if ($(ACC.newSupportTopics.helptopicscategories).length === 0) {
    $('.ph-hide-empty').hide();
  }

  $(document).on('click', '.ph-helptopicscategories__boxes', function() {
    var topicHeader = $(this).attr('data-topicitem'),
        urlLink = window.location.href,
        trigger = 'linkCategory.click',
        compname = 'ph-helptopicscategories__boxes',
        desc = $(this).find('.ph-helptopicscategories_title').text(),
        userEventObj = '';

    $('.ph-mainimagebannercontainer').hide();
    $('.ph-help-header').hide();
    $('.ph-help-subheader').hide();
    $('.ph-alltopics-sec').text('< ' + $('#ph-alltopicstxt').val());
    $('.ph-onthispage').html($('#ph-onthisPage').val() + ':');
    $(ACC.newSupportTopics.helptopicscategories).hide();
    $(ACC.newSupportTopics.questionSection).hide();

    if ($('.ph-countdownbarcontainer').is(':visible')) {
      $(ACC.newSupportTopics.subTopicId).addClass('ph-mb-4');
    }

    $('#ph-' + topicHeader).show();
    trigger = trigger + topicHeader.toLowerCase();
    desc = ACC.newSupportTopics.gaDefaultText + desc;
    userEventObj = ACC.googleanalytics.createUserEventForGa(urlLink, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });
  $(document).on('click', '.ph-tosup-topic', function() {
    var urlLink = window.location.href,
        trigger = 'linkCategory.clickAllSupportTopics',
        compname = 'ph-tosup-topic',
        desc = '',
        userEventObj = '',
        offSet = 100;

    $('.ph-mainimagebannercontainer').show();
    $('.ph-help-header').show();
    $('.ph-help-subheader').show();
    $(ACC.newSupportTopics.helptopicscategories).show();
    $(ACC.newSupportTopics.questionSection).hide();

    if ($(window).width() < 960) {
      offSet = 50;
    }

    $(window).scrollTop($('.ph-helptopics-section').offset().top - offSet);
    setTimeout(function() {
      desc = ACC.newSupportTopics.gaDefaultText + 'Back to ' + $('#ph-alltopicstxt').val();
      userEventObj = ACC.googleanalytics.createUserEventForGa(urlLink, desc, trigger, compname);
      ACC.googleanalytics.gaEventsForLinks(userEventObj);
    }, 100);
  });
  $(document).on('click', '.ph-subtopiclist-header', function() {
    var paraHeader = $(this).attr('data-parasection'),
        urlLink = window.location.href,
        trigger = 'linkCategory.clickSubtopic',
        compname = 'ph-subtopiclist-header',
        desc = ACC.newSupportTopics.gaDefaultText + $.trim($(this).text()),
        userEventObj = '',
        offSet = 200;

    if ($(window).width() < 960) {
      offSet = 150;
    }

    $(window).scrollTop($('#ph-questionsec-' + paraHeader).offset().top - offSet);
    userEventObj = ACC.googleanalytics.createUserEventForGa(urlLink, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });
  $(document).on('click', '.ph-backto-top', function() {
    var urlLink = window.location.href,
        trigger = 'linkCategory.clickBackToTop',
        compname = 'ph-backto-top',
        desc = ACC.newSupportTopics.gaDefaultText + $.trim($(this).text()),
        userEventObj = '';

    $(window).scrollTop(0);
    setTimeout(function() {
      userEventObj = ACC.googleanalytics.createUserEventForGa(urlLink, desc, trigger, compname);
      ACC.googleanalytics.gaEventsForLinks(userEventObj);
    }, 100);
  });
  $(window).on('scroll', function() {
    if ($(ACC.newSupportTopics.questionSection).is(':visible') && $(window).scrollTop() > 150) {
      ACC.newSupportTopics.showStickyHeader();
    } else {
      ACC.newSupportTopics.hideStickyHeader();
    }
  });
});
